// components/Sender/MessageDetailDialog.js
import React, { useState } from "react";

const CHANNEL_META = {
  EMAIL:             { icon: "📧", label: "Email" },
  CONTACT_FORM:      { icon: "📝", label: "Contact form" },
  CALENDLY:          { icon: "📅", label: "Calendly" },
  EMAIL_AND_CONTACT: { icon: "✉️", label: "Email + Contact" },
};

export function MessageDetailDialog({ info, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!info) return null;

  const copy = () => {
    navigator.clipboard.writeText(info.sent_text || "").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => {});
  };

  const channelMeta = CHANNEL_META[info.channel] || {
    icon: "❔", label: info.channel,
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={card}>
        <div style={headerBar}>
          <div>
            <div style={{ color: "#e2e8f0", fontWeight: 700, fontSize: 16,
                          display: "flex", alignItems: "center",
                          gap: 10, flexWrap: "wrap" }}>
              <span>{channelMeta.icon} {channelMeta.label}</span>
              <span style={{ color: "#94a3b8", fontWeight: 400 }}>
                intention #{info.intention_id ?? "—"}
              </span>
              {info.test && (
                <span style={badge("#fbbf24", "#451a03")}>🧪 TEST</span>
              )}
            </div>
            <div style={{ color: "#94a3b8", fontSize: 12, marginTop: 6 }}>
              {info.block_tag} · воркер{" "}
              <b style={{ color: "#cbd5e1" }}>{info.worker}</b>
              {info.worker_sent != null && info.worker_limit != null && (
                <>
                  {" · "}
                  <span style={badge("#1e293b", "#94a3b8")}>
                    [{info.worker_sent}/
                    {info.worker_limit > 0 ? info.worker_limit : "∞"}]
                  </span>
                </>
              )}
              {info.runtime_id && (
                <span style={{
                  marginLeft: 8, fontSize: 11,
                  background: "#1e293b", color: "#94a3b8",
                  padding: "2px 6px", borderRadius: 4,
                  fontFamily: "Consolas, monospace",
                }}>
                  🖥 {info.runtime_id}
                </span>
              )}
            </div>
          </div>
          <button onClick={onClose} style={closeBtn}>✕</button>
        </div>

        <div style={{ flex: 1, overflow: "auto", padding: "16px 20px" }}>

          <Section title="🎯 Цель">
            <KvRow label="target_url">
              {info.target_url ? (
                <a href={info.target_url} target="_blank"
                   rel="noopener noreferrer"
                   style={{ color: "#60a5fa", wordBreak: "break-all" }}>
                  {info.target_url}
                </a>
              ) : <span style={{ color: "#64748b" }}>—</span>}
            </KvRow>
            <KvRow label="Адрес отправки">
              <span style={{ wordBreak: "break-all" }}>
                {info.address || "—"}
              </span>
            </KvRow>
            {info.campaign_id != null && (
              <KvRow label="Кампания">
                #{info.campaign_id}
                {info.campaign_name && (
                  <span style={{ color: "#94a3b8" }}>
                    {" "}— {info.campaign_name}
                  </span>
                )}
              </KvRow>
            )}
            {Array.isArray(info.candidate_channels) &&
             info.candidate_channels.length > 0 && (
              <KvRow label="Каналы intention">
                {info.candidate_channels.map((ch) => {
                  const m = CHANNEL_META[ch] || { icon: "❔", label: ch };
                  return (
                    <span key={ch} style={chip}>
                      {m.icon} {m.label}
                    </span>
                  );
                })}
              </KvRow>
            )}
          </Section>

          {info.channel === "EMAIL" && (
            <Section title="📧 Письмо">
              {info.subject && (
                <KvRow label="Тема">
                  <span style={{ color: "#e2e8f0" }}>{info.subject}</span>
                </KvRow>
              )}
              {info.email_src && (
                <KvRow label="Источник email">
                  {info.email_src === "verified" && (
                    <span style={badge("#dcfce7", "#166534")}>
                      ✅ verified
                    </span>
                  )}
                  {info.email_src === "raw" && (
                    <span style={badge("#fef3c7", "#92400e")}>
                      📋 raw (не верифицирован)
                    </span>
                  )}
                  {info.email_src === "transient" && (
                    <span style={badge("#fee2e2", "#991b1b")}>
                      ⚠️ transient
                    </span>
                  )}
                </KvRow>
              )}
              {info.body && (
                <>
                  <div style={blockLabel}>Тело письма</div>
                  <pre style={preBox}>{info.body}</pre>
                </>
              )}
            </Section>
          )}

          {info.channel === "CONTACT_FORM" && (
            <Section title="📝 Контактная форма">
              {info.form_url && (
                <KvRow label="URL формы">
                  <a href={info.form_url} target="_blank"
                     rel="noopener noreferrer"
                     style={{ color: "#60a5fa", wordBreak: "break-all" }}>
                    {info.form_url}
                  </a>
                </KvRow>
              )}
              {info.submit_status && (
                <KvRow label="Submit">
                  <span style={{
                    color: info.submit_status === "success"
                      ? "#4ade80" : "#fbbf24",
                    fontWeight: 700,
                  }}>
                    {info.submit_status}
                  </span>
                  {info.submit_reason && (
                    <span style={{ color: "#94a3b8" }}>
                      {" "}— {info.submit_reason}
                    </span>
                  )}
                </KvRow>
              )}
              {info.submitted_at && (
                <KvRow label="Отправлено">
                  <span style={{ color: "#cbd5e1" }}>
                    {fmtDateTime(info.submitted_at)}
                  </span>
                </KvRow>
              )}
              {info.fields_source && (
                <KvRow label="Источник полей">
                  <span style={{
                    color: info.fields_source === "payload"
                      ? "#4ade80" : "#fbbf24",
                    fontWeight: 600,
                  }}>
                    {info.fields_source === "payload"
                      ? "✅ из шаблона"
                      : "⚠️ placeholder (шаблон не дал поля)"}
                  </span>
                </KvRow>
              )}
              {Array.isArray(info.fields) && info.fields.length > 0 && (
                <>
                  <div style={blockLabel}>
                    Засабмиченные поля ({info.fields.length})
                  </div>
                  <div style={fieldsBox}>
                    {info.fields.map((f, i) => (
                      <div key={i} style={fieldRow}>
                        <span style={fieldLabel}>
                          {f.label || f.field_name || "?"}
                          {f.field_name && f.label !== f.field_name && (
                            <span style={{ color: "#64748b",
                                           fontSize: 11,
                                           marginLeft: 6 }}>
                              ({f.field_name})
                            </span>
                          )}
                        </span>
                        <span style={fieldValue}>
                          {f.value !== "" && f.value != null
                            ? String(f.value)
                            : <span style={{ color: "#64748b" }}>—</span>}
                          {f.kind === "placeholder" && (
                            <span style={{
                              color: "#fbbf24", fontSize: 10,
                              marginLeft: 6,
                            }}>
                              (placeholder)
                            </span>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </Section>
          )}

          {info.channel === "CALENDLY" && (
            <Section title="📅 Calendly">
              {info.form_url && (
                <KvRow label="URL">
                  <a href={info.form_url} target="_blank"
                     rel="noopener noreferrer"
                     style={{ color: "#60a5fa", wordBreak: "break-all" }}>
                    {info.form_url}
                  </a>
                </KvRow>
              )}
              {info.event_type && (
                <KvRow label="Event type">
                  <span style={{ fontFamily: "Consolas, monospace",
                                 color: "#e2e8f0" }}>
                    {info.event_type}
                  </span>
                </KvRow>
              )}
              {info.slot_date && (
                <KvRow label="Дата">
                  <span style={{ color: "#e2e8f0" }}>
                    {info.slot_date}
                  </span>
                </KvRow>
              )}
              {info.slot_time && (
                <KvRow label="Время">
                  <span style={{ color: "#e2e8f0" }}>
                    {info.slot_time}
                    {info.slot_end_time && `–${info.slot_end_time}`}
                    {info.timezone && ` ${info.timezone}`}
                  </span>
                </KvRow>
              )}
              {info.duration_min && (
                <KvRow label="Длительность">
                  <span style={{ color: "#e2e8f0" }}>
                    {info.duration_min} мин
                  </span>
                </KvRow>
              )}
              {info.invitee_name && (
                <KvRow label="Invitee">
                  <span style={{ color: "#e2e8f0" }}>
                    {info.invitee_name}
                    {info.invitee_email && (
                      <span style={{ color: "#94a3b8" }}>
                        {" "}&lt;{info.invitee_email}&gt;
                      </span>
                    )}
                  </span>
                </KvRow>
              )}
              {info.booking_status && (
                <KvRow label="Статус">
                  <span style={{
                    color: info.booking_status === "confirmed"
                      ? "#4ade80" : "#fbbf24",
                    fontWeight: 700,
                  }}>
                    {info.booking_status}
                  </span>
                </KvRow>
              )}
              {info.confirmation_number && (
                <KvRow label="Подтверждение">
                  <span style={{ fontFamily: "Consolas, monospace",
                                 color: "#93c5fd" }}>
                    {info.confirmation_number}
                  </span>
                </KvRow>
              )}
              {info.booked_at && (
                <KvRow label="Забронировано">
                  <span style={{ color: "#cbd5e1" }}>
                    {fmtDateTime(info.booked_at)}
                  </span>
                </KvRow>
              )}
            </Section>
          )}

          {info.notes && (
            <Section title="ℹ️ Примечания">
              <div style={{ color: "#cbd5e1", fontSize: 13,
                            lineHeight: 1.5 }}>
                {info.notes}
              </div>
            </Section>
          )}

          <details style={{ marginTop: 16 }}>
            <summary style={{ cursor: "pointer", color: "#64748b",
                              fontSize: 12 }}>
              Raw sent_text (можно скопировать)
            </summary>
            <pre style={{ ...preBox, marginTop: 8, maxHeight: 240,
                          overflow: "auto" }}>
              {info.sent_text || "(пусто)"}
            </pre>
          </details>
        </div>

        <div style={footer}>
          <button className="btn-cancel" onClick={copy}>
            {copied ? "✓ Скопировано" : "📋 Копировать текст"}
          </button>
          <div style={{ flex: 1 }} />
          <button className="btn-primary" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{ color: "#93c5fd", fontWeight: 700, fontSize: 13,
                    marginBottom: 8, textTransform: "uppercase",
                    letterSpacing: ".04em" }}>
        {title}
      </div>
      <div style={{ background: "#0f172a", borderRadius: 8,
                    padding: "10px 14px" }}>
        {children}
      </div>
    </div>
  );
}

function KvRow({ label, children }) {
  return (
    <div style={{ display: "grid",
                  gridTemplateColumns: "160px 1fr",
                  gap: 10, marginBottom: 6, fontSize: 13,
                  lineHeight: 1.5, alignItems: "baseline" }}>
      <span style={{ color: "#94a3b8", fontSize: 12 }}>{label}</span>
      <span style={{ color: "#e2e8f0",
                     fontFamily: "Consolas, monospace",
                     wordBreak: "break-word" }}>
        {children}
      </span>
    </div>
  );
}

function fmtDateTime(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("ru-RU"); }
  catch { return String(iso); }
}

function badge(bg, fg) {
  return {
    background: bg, color: fg,
    padding: "2px 8px", borderRadius: 4,
    fontSize: 11, fontWeight: 700,
    display: "inline-block", marginRight: 6,
  };
}

const chip = {
  display: "inline-block",
  padding: "2px 8px",
  marginRight: 6,
  marginBottom: 2,
  borderRadius: 4,
  background: "#1e293b",
  color: "#cbd5e1",
  fontSize: 11,
};

const blockLabel = {
  color: "#94a3b8", fontSize: 12,
  marginTop: 10, marginBottom: 6,
};

const preBox = {
  color: "#e2e8f0", whiteSpace: "pre-wrap", wordBreak: "break-word",
  fontFamily: "Consolas, monospace", fontSize: 13, lineHeight: 1.5,
  padding: 12, background: "#0b1220", borderRadius: 6, margin: 0,
  border: "1px solid #1e293b",
};

const fieldsBox = {
  background: "#0b1220", borderRadius: 6,
  border: "1px solid #1e293b", overflow: "hidden",
};

const fieldRow = {
  display: "grid", gridTemplateColumns: "220px 1fr",
  gap: 10, padding: "8px 12px",
  borderBottom: "1px solid #1e293b",
  fontFamily: "Consolas, monospace", fontSize: 13,
};

const fieldLabel = {
  color: "#93c5fd", fontWeight: 600,
  overflow: "hidden", textOverflow: "ellipsis",
};

const fieldValue = {
  color: "#e2e8f0", wordBreak: "break-word",
};

const closeBtn = {
  background: "none", border: "1px solid #334155",
  color: "#94a3b8", padding: "6px 12px", borderRadius: 6,
  cursor: "pointer", fontSize: 14, height: 32, alignSelf: "flex-start",
};

const overlay = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,.7)",
  backdropFilter: "blur(4px)", zIndex: 1300,
  display: "flex", alignItems: "center", justifyContent: "center",
  padding: 20,
};
const card = {
  background: "#0b1220", borderRadius: 14, width: "100%",
  maxWidth: 900, maxHeight: "92vh", display: "flex",
  flexDirection: "column", overflow: "hidden",
  border: "1px solid #1e293b",
};
const headerBar = {
  padding: "16px 20px", borderBottom: "1px solid #1e293b",
  display: "flex", justifyContent: "space-between",
  alignItems: "flex-start", gap: 10,
};
const footer = {
  padding: "12px 20px", borderTop: "1px solid #1e293b",
  display: "flex", gap: 8, alignItems: "center",
};